import React from 'react';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import propTypes from 'prop-types';

// components
import { Button, Modal } from '@tcc/crate';

const baseString = 'vra-base-modal';
const bsString = 'vra-modal';
let BaseModal = ({
  cancelText=getMessage('button-text__cancel'),
  children,
  className,
  saveOption,
  footerText,
  header,
  isInvalid=false,
  isOpen=true,
  onCancel,
  onSave,
  onSendToDrive,
  saveText=getMessage('button-text__save-changes'),
  sendText=getMessage('button-text__send-to-drive'),
  shouldCloseOnOverlayClick=true
}) => {

  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: true,
    [`${bsString}__wrapper`]: true,
    [`${bsString}__wrapper--no-title`]: !header
  });

  const modalHeader = header ? (
    <header className={`${bsString}-header`}>
      {header}
    </header>
  ) : null;

  return (
    <Modal
      className={bsString}
      onClose={shouldCloseOnOverlayClick ? onCancel : undefined}
      show={isOpen}
      size='M'>

      <section className={classString}>
        {modalHeader}
        <section className={`${bsString}-body__content`}>
          {children}
        </section>
        <footer className={`${bsString}-footer`}>
          <Button
            className={`${bsString}__button`}
            data-test-id={`${bsString}-button-0`}
            key={`${bsString}-button-0`}
            mode='secondary'
            onClick={onCancel}>
            {cancelText}
          </Button>
          {saveOption
            ? <Button
              className={`${bsString}__button`}
              data-test-id={`${bsString}-button-2`}
              disabled={isInvalid}
              key={`${bsString}-button-2`}
              mode='primary'
              onClick={() => { onSendToDrive(); }}>
              {sendText}
            </Button>
            : <Button
              className={`${bsString}__button`}
              data-test-id={`${bsString}-button-1`}
              disabled={isInvalid}
              key={`${bsString}-button-1`}
              mode='primary'
              onClick={() => { onSave(); }}>
              {saveText}
            </Button>}
          <small>{footerText}</small>
        </footer>
      </section>

    </Modal>
  );
};

BaseModal.propTypes = {
  cancelText: propTypes.string,
  children: propTypes.node,
  className: propTypes.string,
  footerText: propTypes.string,
  header: propTypes.string,
  isInvalid: propTypes.bool,
  isOpen: propTypes.bool,
  onCancel: propTypes.func.isRequired,
  onSave: propTypes.func.isRequired,
  onSendToDrive: propTypes.func,
  saveOption: propTypes.string,
  saveText: propTypes.string,
  sendText: propTypes.string,
  shouldCloseOnOverlayClick: propTypes.bool
};
export default BaseModal;
